import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-13f14e4c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { id: "map_location" }

import {
  createPopup,
  createMap,
  getDeviceClass,
  formatLat,
  formatLng,
} from '@/utils/map.utils'
import { ref, onMounted, onUnmounted, watch } from 'vue'
import { obj } from './test.js'
import L from 'leaflet'


export default /*#__PURE__*/_defineComponent({
  __name: 'index',
  setup(__props) {

console.log(obj, '====')

let map: any = null
onMounted(async () => {
  map = createMap('map_location')

  ttt()
  c()
})

const c = () => {
  const ll = obj.map((lngLat: any) => {
    const [longitude, latitude] = lngLat.split(',')
    return [latitude, longitude]
  })

  map.fitBounds(ll)
}

const ttt = () => {
  obj.map((lngLat: any) => {
    const m = createMarker(lngLat)
    console.log(m, 'mm')
    m.addTo(map)
  })
}

const createMarker = (lngLat: string) => {
  const [longitude, latitude] = lngLat.split(',')
  console.log(latitude, 'latitudelatitudelatitude')

  const marker = L.marker([latitude, longitude], {
    icon: new L.divIcon({
      iconSize: [49, 62],
      iconAnchor: [25, 60],
      className: 'map-' + 'DEFAULT',
    }),
  })
  const popup = createPopup({})

  marker.bindPopup(popup)
  marker.off('click')
  marker.on('click', async (e: any) => {
    const { latlng } = e
    popup.setContent(`
    <p>${lngLat}</p>
  `)

    marker.openPopup()
  })

  return marker
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1))
}
}

})